
import { supabase } from '@/integrations/supabase/client';
import { AuditLog } from '@/types/database';

export const auditService = {
  // Log an action to the audit trail
  async logAction(
    actionType: string,
    targetTable: string,
    targetId: string,
    additionalInfo?: any
  ): Promise<AuditLog | null> {
    try {
      const user = (await supabase.auth.getUser()).data.user;
      if (!user) {
        console.warn('No authenticated user for audit log');
        return null;
      }

      const { data, error } = await supabase
        .from('audit_logs')
        .insert({
          action_type: actionType,
          target_table: targetTable,
          target_id: targetId,
          user_id: user.id,
          additional_info: additionalInfo
        })
        .select()
        .single();

      if (error) {
        console.error('Error creating audit log:', error);
        return null;
      }

      return data as AuditLog;
    } catch (error) {
      console.error('Error in audit logging:', error);
      return null;
    }
  },

  // Get audit logs for the current user
  async getUserAuditLogs(limit?: number): Promise<AuditLog[]> {
    try {
      let query = supabase
        .from('audit_logs')
        .select('*')
        .order('created_at', { ascending: false });

      if (limit) {
        query = query.limit(limit);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching audit logs:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      return [];
    }
  },

  // Get audit logs for a specific target
  async getTargetAuditLogs(targetTable: string, targetId: string): Promise<AuditLog[]> {
    try {
      const { data, error } = await supabase
        .from('audit_logs')
        .select('*')
        .eq('target_table', targetTable)
        .eq('target_id', targetId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching target audit logs:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error fetching target audit logs:', error);
      return [];
    }
  }
};
